import { render, staticRenderFns } from "./icon-load.vue?vue&type=template&id=26aecfda&"
import script from "./icon-load.vue?vue&type=script&lang=js&"
export * from "./icon-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports